// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Inter", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  line-height: 1.7;
  color: #1A1A1A;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.rc-content h1 {
  font-size: 26px;
  font-weight: 500;
  line-height: 1.3;
  margin: 28px 0 12px;
  color: #1A1A1A;
}
.rc-content h2 {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.3;
  margin: 26px 0 10px;
  color: #1A1A1A;
}
.rc-content h3 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.35;
  margin: 22px 0 8px;
  color: #1A1A1A;
}
.rc-content h4 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  margin: 18px 0 6px;
  color: #1A1A1A;
}
.rc-content h5, .rc-content h6 {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6B7280;
  margin: 16px 0 6px;
}
.rc-content h1:first-child,
.rc-content h2:first-child,
.rc-content h3:first-child,
.rc-content h4:first-child {
  margin-top: 0;
}
.rc-content p {
  margin: 0 0 16px;
}
.rc-content ul, .rc-content ol {
  margin: 0 0 16px;
  padding-left: 22px;
}
.rc-content ul li, .rc-content ol li {
  margin: 6px 0;
  line-height: 1.6;
}
.rc-content ul li::marker, .rc-content ol li::marker {
  color: #A0A4AB;
}
.rc-content ul ul, .rc-content ul ol, .rc-content ol ul, .rc-content ol ol {
  margin: 6px 0;
}
.rc-content strong, .rc-content b {
  font-weight: 600;
  color: inherit;
}
.rc-content em, .rc-content i {
  font-style: italic;
}
.rc-content a {
  color: #1A73E8;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.rc-content a:hover {
  color: #1558B0;
}
.rc-content code:not(pre code) {
  font-family: "Fira Code", "Cascadia Code", Consolas, "Liberation Mono", monospace;
  font-size: 0.9em;
  background: #E8EAED;
  padding: 1px 6px;
  border-radius: 4px;
  color: #1A1A1A;
}
.rc-content blockquote {
  margin: 16px 0;
  padding: 4px 14px;
  border-left: 3px solid #E5E7EB;
  color: #6B7280;
}
.rc-content hr {
  border: none;
  border-top: 1px solid #E5E7EB;
  margin: 24px 0;
}
.rc-content > *:last-child {
  margin-bottom: 0;
}

.rc-cite {
  display: inline;
  color: #1A73E8;
  font-weight: 600;
  cursor: pointer;
  padding: 0 2px;
  border-radius: 3px;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.rc-cite:hover, .rc-cite:focus-visible {
  background: rgba(26, 115, 232, 0.1);
  color: #1558B0;
  outline: none;
}

.rc-svg-btn, .rc-csv-btn, .rc-copy-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid #E5E7EB;
  background: #FFFFFF;
  color: #6B7280;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}
.rc-svg-btn:hover, .rc-csv-btn:hover, .rc-copy-btn:hover {
  background: #E5E7EB;
  border-color: #bbb;
}

.rc-table-wrap {
  position: relative;
  margin: 14px 0;
  border: 1px solid transparent;
  border-radius: 8px;
  overflow: hidden;
}
.rc-table-wrap:hover .rc-table-toolbar, .rc-table-wrap:focus-within .rc-table-toolbar {
  opacity: 1;
  visibility: visible;
}

.rc-table-toolbar {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 1;
  display: flex;
  gap: 2px;
  padding: 0;
  background: transparent;
  border: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease;
}
@media (hover: none) {
  .rc-table-toolbar {
    opacity: 1;
    visibility: visible;
  }
}
.rc-table-toolbar .rc-copy-btn,
.rc-table-toolbar .rc-csv-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  gap: 0;
  border: none;
  background: rgba(255, 255, 255, 0.92);
  color: #A0A4AB;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, color 0.15s ease;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
}
.rc-table-toolbar .rc-copy-btn:hover,
.rc-table-toolbar .rc-csv-btn:hover {
  background: #E8EAED;
  color: #1A73E8;
  border-color: transparent;
}
.rc-table-toolbar .rc-copy-btn svg,
.rc-table-toolbar .rc-csv-btn svg {
  width: 14px;
  height: 14px;
  display: block;
}

.rc-table-scroll {
  overflow-x: auto;
}
.rc-table-scroll table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  line-height: 1.5;
}
.rc-table-scroll th {
  background: #E5E7EB;
  font-weight: 600;
  text-align: left;
}
.rc-table-scroll tr:nth-child(even) td {
  background: #fafafa;
}
.rc-table-scroll td,
.rc-table-scroll th {
  padding: 8px 14px;
  border: 1px solid transparent;
}

.rc-code-block {
  position: relative;
  border-radius: 8px;
  background: #1e1e1e;
  margin: 14px 0;
  overflow: hidden;
}
.rc-code-block pre {
  margin: 0;
  padding: 14px 16px;
  overflow-x: auto;
}
.rc-code-block code {
  font-size: 14px;
  line-height: 1.6;
  font-family: "Fira Code", "Cascadia Code", Consolas, "Liberation Mono", monospace;
  color: #d4d4d4;
}

.rc-code-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  background: #2d2d2d;
  border-bottom: 1px solid #3a3a3a;
}
.rc-code-toolbar .rc-lang-badge {
  font-size: 11px;
  color: #999;
  font-family: monospace;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.rc-code-toolbar .rc-copy-btn {
  background: transparent;
  border-color: #555;
  color: #ccc;
}
.rc-code-toolbar .rc-copy-btn:hover {
  background: #3a3a3a;
  border-color: #777;
  color: #fff;
}

.rc-mermaid-wrap {
  margin: 14px 0;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}

.rc-mermaid-toolbar {
  display: flex;
  gap: 8px;
  padding: 7px 12px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.rc-mermaid-svg {
  padding: 20px;
  text-align: center;
  overflow-x: auto;
  background: #FFFFFF;
}
.rc-mermaid-svg svg {
  max-width: 100%;
  height: auto;
}

.rc-math-block {
  display: block;
  overflow-x: auto;
  text-align: center;
  padding: 10px 0;
  margin: 10px 0;
}
.rc-math-block .katex {
  font-size: 1.1em;
}

.rc-math-inline {
  display: inline;
}
.rc-math-inline .katex {
  font-size: 1em;
}

.rc-math-error {
  color: #D92D20;
  font-family: monospace;
  font-size: 12px;
}

.rc-content .rc-image {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 8px 0;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/richcontent/RichContent.scss","webpack://./src/app/assets/scss/utils/_variables.scss"],"names":[],"mappings":"AAIA;EAGE,gHCiF4B;EDhF5B,eCkF4B;EDjF5B,gBCkF4B;EDjF5B,cCwE4B;EDvE5B,mCAAA;EACA,kCAAA;AALF;AAQE;EACE,eAAA;EACA,gBC2E0B;ED1E1B,gBAAA;EACA,mBAAA;EACA,cC8D0B;ADpE9B;AASE;EACE,eAAA;EACA,gBCmE0B;EDlE1B,gBAAA;EACA,mBAAA;EACA,cCsD0B;AD7D9B;AAUE;EACE,eAAA;EACA,gBC2D0B;ED1D1B,iBAAA;EACA,kBAAA;EACA,cC8C0B;ADtD9B;AAWE;EACE,eAAA;EACA,gBCmD0B;EDlD1B,gBAAA;EACA,kBAAA;EACA,cCsC0B;AD/C9B;AAYE;EACE,eAAA;EACA,gBC2C0B;ED1C1B,sBAAA;EACA,yBAAA;EACA,cCgC0B;ED/B1B,kBAAA;AAVJ;AAaE;;;;EAGiB,aAAA;AAVnB;AAYE;EAAI,gBAAA;AATN;AAWE;EACE,gBAAA;EACA,kBAAA;AATJ;AAWI;EACE,aAAA;EACA,gBAAA;AATN;AAWM;EAAY,cCYY;ADpB9B;AAYE;EACE,aAAA;AAVJ;AAcE;EACE,gBAAA;EACA,cAAA;AAZJ;AAeE;EAAQ,kBAAA;AAZV;AAcE;EACE,cCnFY;EDoFZ,0BAAA;EACA,0BAAA;AAZJ;AAcI;EAAU,cCIgB;ADf9B;AAcE;EACE,iFAAA;EACA,gBAAA;EACA,mBCQ0B;EDP1B,gBAAA;EACA,kBAAA;EACA,cCnB0B;ADO9B;AAgBE;EACE,cAAA;EACA,iBAAA;EACA,8BAAA;EACA,cCzB0B;ADW9B;AAiBE;EACE,YAAA;EACA,6BAAA;EACA,cAAA;AAfJ;AAkBE;EAAiB,gBAAA;AAfnB;;AAoBA;EACE,eAAA;EACA,cCxHc;EDyHd,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,yDAAA;AAjBF;AAmBE;EAEE,mCAAA;EACA,cCvC0B;EDwC1B,aAAA;AAlBJ;;AAwBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBC/E4B;EDgF5B,cCpE4B;EDqE5B,eAAA;EACA,gDAAA;EACA,mBAAA;AArBF;AAuBE;EACE,mBCnF0B;EDoF1B,kBAAA;AArBJ;;AA+BA;EACE,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;AA5BF;AA+BE;EAEE,UAAA;EACA,mBAAA;AA9BJ;;AAqCA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;AAlCF;AAqCE;EAfF;IAgBI,UAAA;IACA,mBAAA;EAlCF;AACF;AAuCE;;EAEE,WAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,qCAAA;EACA,cCvI0B;EDwI1B,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;EACA,4CAAA;AArCJ;AAuCI;;EACE,mBCzHwB;ED0HxB,cC/NU;EDgOV,yBAAA;AApCN;AAuCI;;EACE,WAAA;EACA,YAAA;EACA,cAAA;AApCN;;AAyCA;EACE,gBAAA;AAtCF;AAwCE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAtCJ;AAyCE;EACE,mBChL0B;EDiL1B,gBAAA;EACA,gBAAA;AAvCJ;AA0CE;EACE,mBAAA;AAxCJ;AA2CE;;EAEE,iBAAA;EACA,6BAAA;AAzCJ;;AA+CA;EACE,kBAAA;EACA,kBAAA;EACA,mBC7J4B;ED8J5B,cAAA;EACA,gBAAA;AA5CF;AA8CE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AA5CJ;AA+CE;EACE,eAAA;EACA,gBAAA;EACA,iFAAA;EACA,cCxK0B;AD2H9B;;AAiDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBCnL4B;EDoL5B,gCAAA;AA9CF;AAgDE;EACE,eAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AA9CJ;AAiDE;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;AA/CJ;AAiDI;EACE,mBCnMwB;EDoMxB,kBAAA;EACA,WAAA;AA/CN;;AAsDA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAnDF;;AAsDA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AAnDF;;AAsDA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBC5Q4B;ADyN9B;AAqDE;EACE,eAAA;EACA,YAAA;AAnDJ;;AAyDA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAtDF;AAwDE;EAAS,gBAAA;AArDX;;AAwDA;EACE,eAAA;AArDF;AAsDE;EAAS,cAAA;AAnDX;;AAsDA;EACE,cChQ4B;EDiQ5B,sBAAA;EACA,eAAA;AAnDF;;AAwDA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AArDF","sourcesContent":["@use '../../../assets/scss/utils/variables' as *;\n\n// ── Markdown typography ───────────────────────────────────────────────────────\n\n.rc-content {\n  // Override the Montserrat inherited from .unified-feed. System-UI stack\n  // renders bold text with calmer weight — matches ChatGPT/Claude/Gemini.\n  font-family: $chat-reading-font;\n  font-size: $chat-reading-size;\n  line-height: $chat-reading-leading;\n  color: $chat-text-primary;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n\n  // Heading ladder — semibold only, generous top margin.\n  h1 {\n    font-size: 26px;\n    font-weight: $chat-heading-weight;\n    line-height: 1.3;\n    margin: 28px 0 12px;\n    color: $chat-text-primary;\n  }\n\n  h2 {\n    font-size: 22px;\n    font-weight: $chat-heading-weight;\n    line-height: 1.3;\n    margin: 26px 0 10px;\n    color: $chat-text-primary;\n  }\n\n  h3 {\n    font-size: 18px;\n    font-weight: $chat-heading-weight;\n    line-height: 1.35;\n    margin: 22px 0 8px;\n    color: $chat-text-primary;\n  }\n\n  h4 {\n    font-size: 16px;\n    font-weight: $chat-heading-weight;\n    line-height: 1.4;\n    margin: 18px 0 6px;\n    color: $chat-text-primary;\n  }\n\n  h5, h6 {\n    font-size: 13px;\n    font-weight: $chat-heading-weight;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: $chat-text-secondary;\n    margin: 16px 0 6px;\n  }\n\n  h1:first-child,\n  h2:first-child,\n  h3:first-child,\n  h4:first-child { margin-top: 0; }\n\n  p { margin: 0 0 16px; }\n\n  ul, ol {\n    margin: 0 0 16px;\n    padding-left: 22px;\n\n    li {\n      margin: 6px 0;\n      line-height: 1.6;\n\n      &::marker { color: $chat-text-muted; }\n    }\n  }\n\n  ul ul, ul ol, ol ul, ol ol {\n    margin: 6px 0;\n  }\n\n  // Emphasis — semibold, inherit color so bolds don't compete with headings.\n  strong, b {\n    font-weight: 600;\n    color: inherit;\n  }\n\n  em, i { font-style: italic; }\n\n  a {\n    color: $chat-primary;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover { color: $chat-primary-hover; }\n  }\n\n  code:not(pre code) {\n    font-family: 'Fira Code', 'Cascadia Code', Consolas, 'Liberation Mono', monospace;\n    font-size: 0.9em;\n    background: $chat-surface-hover;\n    padding: 1px 6px;\n    border-radius: 4px;\n    color: $chat-text-primary;\n  }\n\n  // Blockquote — quieter. No italic (industry convention).\n  blockquote {\n    margin: 16px 0;\n    padding: 4px 14px;\n    border-left: 3px solid $chat-border-subtle;\n    color: $chat-text-secondary;\n  }\n\n  hr {\n    border: none;\n    border-top: 1px solid $chat-border-subtle;\n    margin: 24px 0;\n  }\n\n  > *:last-child { margin-bottom: 0; }\n}\n\n// ── Inline citation markers ──────────────────────────────────────────────────\n\n.rc-cite {\n  display: inline;\n  color: $chat-primary;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0 2px;\n  border-radius: 3px;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba(26, 115, 232, 0.1);\n    color: $chat-primary-hover;\n    outline: none;\n  }\n}\n\n// ── Shared button style ───────────────────────────────────────────────────────\n\n%rc-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: 1px solid $chat-border;\n  background: $chat-bg;\n  color: $chat-text-secondary;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  white-space: nowrap;\n\n  &:hover {\n    background: $chat-border-subtle;\n    border-color: #bbb;\n  }\n}\n\n.rc-copy-btn { @extend %rc-btn; }\n.rc-csv-btn  { @extend %rc-btn; }\n.rc-svg-btn  { @extend %rc-btn; }\n\n// ── Tables ────────────────────────────────────────────────────────────────────\n\n.rc-table-wrap {\n  position: relative;\n  margin: 14px 0;\n  border: 1px solid $chat-sidebar-border;\n  border-radius: 8px;\n  overflow: hidden;\n\n  // Reveal table action buttons on hover or focus-within\n  &:hover .rc-table-toolbar,\n  &:focus-within .rc-table-toolbar {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n// Floating top-right toolbar — icon buttons revealed on table hover.\n// Drops the legacy grey strip; absolutely positioned so it overlays the\n// table corner without affecting layout.\n.rc-table-toolbar {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  z-index: 1;\n  display: flex;\n  gap: 2px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease;\n\n  // Always visible on touch / no-hover devices\n  @media (hover: none) {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  // Override the shared %rc-btn text styles for icon-only buttons here.\n  // (.rc-copy-btn / .rc-csv-btn keep their default text styling everywhere\n  // else — code-block and mermaid toolbars still need it.)\n  .rc-copy-btn,\n  .rc-csv-btn {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    gap: 0;\n    border: none;\n    background: rgba(255, 255, 255, 0.92);\n    color: $chat-text-muted;\n    border-radius: 6px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.15s ease, color 0.15s ease;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);\n\n    &:hover {\n      background: $chat-surface-hover;\n      color: $chat-primary;\n      border-color: transparent;\n    }\n\n    svg {\n      width: 14px;\n      height: 14px;\n      display: block;\n    }\n  }\n}\n\n.rc-table-scroll {\n  overflow-x: auto;\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    line-height: 1.5;\n  }\n\n  th {\n    background: $chat-border-subtle;\n    font-weight: 600;\n    text-align: left;\n  }\n\n  tr:nth-child(even) td {\n    background: #fafafa;\n  }\n\n  td,\n  th {\n    padding: 8px 14px;\n    border: 1px solid $chat-sidebar-border;\n  }\n}\n\n// ── Code blocks ───────────────────────────────────────────────────────────────\n\n.rc-code-block {\n  position: relative;\n  border-radius: 8px;\n  background: $chat-code-bg;\n  margin: 14px 0;\n  overflow: hidden;\n\n  pre {\n    margin: 0;\n    padding: 14px 16px;\n    overflow-x: auto;\n  }\n\n  code {\n    font-size: 14px;\n    line-height: 1.6;\n    font-family: 'Fira Code', 'Cascadia Code', Consolas, 'Liberation Mono', monospace;\n    color: $chat-code-text;\n  }\n}\n\n.rc-code-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 12px;\n  background: $chat-code-toolbar-bg;\n  border-bottom: 1px solid $chat-code-border;\n\n  .rc-lang-badge {\n    font-size: 11px;\n    color: #999;\n    font-family: monospace;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  .rc-copy-btn {\n    background: transparent;\n    border-color: #555;\n    color: #ccc;\n\n    &:hover {\n      background: $chat-code-border;\n      border-color: #777;\n      color: #fff;\n    }\n  }\n}\n\n// ── Mermaid diagrams ──────────────────────────────────────────────────────────\n\n.rc-mermaid-wrap {\n  margin: 14px 0;\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.rc-mermaid-toolbar {\n  display: flex;\n  gap: 8px;\n  padding: 7px 12px;\n  background: #f8f8f8;\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.rc-mermaid-svg {\n  padding: 20px;\n  text-align: center;\n  overflow-x: auto;\n  background: $chat-bg;\n\n  svg {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n// ── Math formulas ─────────────────────────────────────────────────────────────\n\n.rc-math-block {\n  display: block;\n  overflow-x: auto;\n  text-align: center;\n  padding: 10px 0;\n  margin: 10px 0;\n\n  .katex { font-size: 1.1em; }\n}\n\n.rc-math-inline {\n  display: inline;\n  .katex { font-size: 1em; }\n}\n\n.rc-math-error {\n  color: $chat-error;\n  font-family: monospace;\n  font-size: 12px;\n}\n\n// ── Images ────────────────────────────────────────────────────────────────────\n\n.rc-content .rc-image {\n  max-width: 100%;\n  height: auto;\n  border-radius: 6px;\n  margin: 8px 0;\n  display: block;\n}\n","// General variables\n$theme-body-font-color: #000000;\n$body-color: #F6F7F9;\n\n// Theme colors variables\n$primary-color: #1A73E8;\n$secondary-color: #CE002A;\n$auth-primary-color:#F69525;\n$success-color: #17D664;\n$info-color : #a927f9;\n$warning-color: #f8d62b;\n$danger-color: #EC1F1F;\n$light-color : #f4f4f4;\n$light-gray : #ecf3fa;\n$light-semi-gray :#efefef;\n$dark-gray: #898989;\n$dark-color : #2c323f;\n$gray-60 :#cccccc;\n$card-body-color : #f9f9fa;\n$transparent-color: transparent;\n$auth-bg-color:#fafafa;\n$light : #fdfeff;\n$semi-dark :#59667a;\n$light-text: #999999;\n$light-background: #d7e2e9;\n$light-font: rgba(27, 49, 85, 0.4);\n$light-semi-font: $semi-dark;\n$light-chartist-grid-color: #f6f9fd;\n$pitch-color: #fe8a7d;\n$color-scarpa: #4c5667;\n$color-fiord: #455a64;\n$black : #000;\n$white:#fff;\n$table-head-bg:#e8eaec;\n$green-text:#0EC60E;\n$circulargraph-blue : #0d6efd;\n$circulargraph-green : #3DD598;\n$circulargraph-yellow : #FF974A;\n$graph-primary:#3DD598;\n$graph-secondary:#0062FF;\n$graph-c:#6200ff;\n$dbd-primary-graph:#FFE223;\n$dbd-graph-secondary:#11E1A3;\n\n// gradient colors\n$gradient-primary: linear-gradient(26deg, var(--theme-deafult) 0%, #a26cf8 100%);\n\n//social colors\n$fb: #50598e;\n$twitter: #6fa2d8;\n$google-plus: #c64e40;\n$linkedin: #0077B5;\n\n//radius\n$radius:3px;\n$curveradius:15px;\n$radius-md:10px;\n\n//fonts\n$primary-font:'Montserrat', sans-serif;\n$font-serif: sans-serif;\n$body-font-size:13px;\n$body-font-size-medium:12px;\n\n// ── Unified Chat Tokens ────────────────────────────────────────────────────────\n\n// Layout\n$chat-sidebar-width:          285px;\n$chat-sidebar-bg:             #F4F6F7;\n$chat-sidebar-border:         transparent;\n\n// Chat surface\n$chat-bg:                     #FFFFFF;  // main feed area\n$chat-page-bg:                #F4F6F7;  // outer page + sidebar bg\n$chat-surface:                #FFFFFF;\n$chat-border-subtle:          #E5E7EB;\n$chat-message-gap:            20px;\n$chat-feed-padding-h:         60px;\n$chat-content-max-width:      720px;   // chat message column width (design 02/03)\n\n// Typography\n$chat-title-color:            #1A1A1A;\n$chat-text-primary:           #1A1A1A;\n$chat-text-muted:             #A0A4AB;\n$chat-text-secondary:         #6B7280;\n\n// Reading-area typography — used by AI response markdown only.\n// System-UI stack so bolds render naturally (matches ChatGPT/Claude/Gemini).\n$chat-reading-font:           -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Inter\",\n                              Roboto, \"Helvetica Neue\", Arial, sans-serif;\n$chat-reading-size:           16px;\n$chat-reading-leading:        1.7;\n$chat-heading-weight:         500;   // medium — 500 in system-UI optically matches ChatGPT/Claude 600 in their custom faces\n\n// Interactive\n$chat-primary:                $primary-color;   // #1A73E8\n$chat-primary-hover:          #1558B0;\n\n// Input\n$chat-input-border:           #E5E7EB;\n$chat-input-radius:           16px;\n$chat-input-shadow:           0 4px 14px rgba(16, 24, 40, 0.08);\n\n// Borders and surfaces\n$chat-border:                 #E5E7EB;\n$chat-border-light:           #EEF0F2;\n$chat-surface-hover:          #E8EAED;\n$chat-surface-active:         #E1E5EA;\n\n// Status\n$chat-error:                  #D92D20;\n$chat-success:                #17D664;\n$chat-thinking-color:         $primary-color;\n\n// Code blocks\n$chat-code-bg:                #1e1e1e;\n$chat-code-toolbar-bg:        #2d2d2d;\n$chat-code-border:            #3a3a3a;\n$chat-code-text:              #d4d4d4;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
